import { useQueryClient } from "@tanstack/react-query";
import { ComponentType, useCallback, useEffect, useMemo, useState } from "react";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import TabletWrapper from "@/shared/widgets/TabletWrapper";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";
import { HeaderTabsEnum } from "@/domains/faction/constants/headerTabsEnum";
import { changeFaction, factionSelector } from "@/domains/faction/slice";
import { factionsList } from "@/domains/faction/helpers/factionsList";
import { getFactionTabContent } from "@/domains/faction/helpers/getFactionTabContent";
import { QUERY_KEY_FACTION_BLACK_LIST } from "@/domains/faction/hooks/useGetBlackList";
import { QUERY_KEY_FACTION_GENERAL_INFO } from "@/domains/faction/hooks/useGetInfo";
import { QUERY_KEY_FACTION_COLLEAGUES_INFO } from "@/domains/faction/hooks/useGetParticipants";
import { QUERY_KEY_FACTION_REQUESTS } from "@/domains/faction/hooks/useGetRequests";
import FactionHeader from "@/domains/faction/components/FactionHeader";
import FactionWrapper from "@/domains/faction/components/FactionWrapper";

export default function FactionContainer() {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const [activeHeaderTab, setActiveHeaderTab] = useState<HeaderTabsEnum>(
    HeaderTabsEnum.INFORMATION,
  );

  const faction = useAppSelector(factionSelector);

  const { tabsList, tabsMap } = useMemo(() => getFactionTabContent(), []);

  type TabProps = { faction: FactionEnum };
  const ActiveComponent = tabsMap[activeHeaderTab] as ComponentType<TabProps>;

  const closeTablet = useCallback(() => GameMpProvider.closeCurrentInterface(true), []);

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: [QUERY_KEY_FACTION_GENERAL_INFO] });
      queryClient.removeQueries({ queryKey: [QUERY_KEY_FACTION_COLLEAGUES_INFO] });
      queryClient.removeQueries({ queryKey: [QUERY_KEY_FACTION_BLACK_LIST] });
      queryClient.removeQueries({ queryKey: [QUERY_KEY_FACTION_REQUESTS] });
    };
  }, [queryClient]);

  if (!ActiveComponent) return null;

  return (
    // TODO Удалить после полного окончания верстки на локалке |||||
    // <TabletWrapper className="m-auto">
    //   <FactionWrapper dataMzAccent={factionsList?.[faction]?.dataMzAccent}>
    //     <FactionHeader
    //       src={factionsList?.[faction]?.src}
    //       headerSrc={factionsList?.[faction]?.headerSrc}
    //       headerList={tabsList}
    //       activeHeaderTab={activeHeaderTab}
    //       setActiveHeaderTab={setActiveHeaderTab}
    //       onClose={() => {}}
    //     />
    //     <ActiveComponent faction={faction} />
    //   </FactionWrapper>
    // </TabletWrapper>
    <FactionWrapper dataMzAccent={factionsList?.[faction]?.dataMzAccent}>
      <FactionHeader
        src={factionsList?.[faction]?.src}
        headerSrc={factionsList?.[faction]?.headerSrc}
        headerList={tabsList}
        activeHeaderTab={activeHeaderTab}
        setActiveHeaderTab={setActiveHeaderTab}
        onClose={closeTablet}
      />
      <ActiveComponent faction={faction} />
      {/* <button
        type="button"
        className="absolute z-2 bottom-0 left-0 size-7 rounded-full bg-[#088b6b]"
        onClick={() => dispatch(changeFaction(FactionEnum.RUSSIANARMY))}
      />
      <button
        type="button"
        className="absolute z-2 bottom-0 left-8 size-7 rounded-full bg-[#8b1108]"
        onClick={() => dispatch(changeFaction(FactionEnum.HOSPITAL))}
      />
      <button
        type="button"
        className="absolute z-2 bottom-0 left-16 size-7 rounded-full bg-[#08328b]"
        onClick={() => dispatch(changeFaction(FactionEnum.MEDSI))}
      />
      <button
        type="button"
        className="absolute z-2 bottom-0 left-24 size-7 rounded-full bg-[#213ac7]"
        onClick={() => dispatch(changeFaction(FactionEnum.REGION24))}
      /> */}
    </FactionWrapper>
  );
}
